const SINHALA_PYTHON_COURSE = require("./sinhala/python_course")
const SINHALA_ARDUINO_COURSE = require("./sinhala/arduino_course")

module.exports = [SINHALA_PYTHON_COURSE, SINHALA_ARDUINO_COURSE]
